import { Skeleton } from '@/domains/core/tamagoshi/Skeleton/Skeleton';

import styles from './PlaylistFilterSkeleton.module.scss';

export const PlaylistFilterSkeleton = () => (
  <Skeleton className={styles.playlistFilterSkeleton} />
);

PlaylistFilterSkeleton.displayName = 'PlaylistFilterSkeleton';
